export const isCompletedUpload = (
  entry: unknown,
): entry is { name: string; url: string; type: string } =>
  !!entry &&
  typeof entry === "object" &&
  !(entry instanceof File) &&
  "name" in entry &&
  typeof entry.name === "string" &&
  "url" in entry &&
  typeof entry.url === "string" &&
  entry.url.length > 0 &&
  "type" in entry &&
  typeof entry.type === "string";

export const isValidImageDimensions = async (file: File, min: number, max: number) => {
  const allowedMime = ["image/jpeg", "image/jpg", "image/png", "image/bmp", "image/gif"];
  const ext = file.name.split(".").pop()?.toLowerCase();
  const allowedExt = ["jpg", "jpeg", "png", "bmp", "gif"];

  if (!(allowedMime.includes(file.type) || (ext && allowedExt.includes(ext)))) {
    return false;
  }

  return new Promise<boolean>((resolve) => {
    const img = new window.Image();
    img.onload = () => {
      resolve(img.width >= min && img.height >= min && img.width <= max && img.height <= max);
    };
    img.onerror = () => resolve(false);
    img.src = URL.createObjectURL(file);
  });
};
